import React, { useState, useEffect } from 'react';
import { Tabs, Modal, Layout, Typography } from '@douyinfe/semi-ui';
import { useTokenQuery } from '../hooks/useTokenQuery';
import TokenInput from './dashboard/TokenInput';
import StatusCards from './dashboard/StatusCards';
import UsageChart from './dashboard/UsageChart';
import LogsList from './dashboard/LogsList';
import { ITEMS_PER_PAGE } from '../constants';

const { Text, Paragraph } = Typography;
const { TabPane } = Tabs;
const { Content, Footer } = Layout;

const LogsTable = () => {
    const {
        apikey,
        setAPIKey,
        loading,
        baseUrls,
        activeTabKey,
        handleTabChange,
        fetchData,
        activeTabData
    } = useTokenQuery();

    const [pageSize, setPageSize] = useState(ITEMS_PER_PAGE);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [dollarCost, setDollarCost] = useState('0.5');
    const [showRMB, setShowRMB] = useState(false);

    // 公告逻辑
    const [showAnnouncement, setShowAnnouncement] = useState(false);
    const [announcementData, setAnnouncementData] = useState(null);

    useEffect(() => {
        fetch('/announcement.json')
            .then(res => res.json())
            .then(data => {
                setAnnouncementData(data);
                if (data.enabled) setShowAnnouncement(true);
            })
            .catch(err => console.log('公告加载失败:', err));
    }, []);

    const renderContent = () => {
        const hasData = activeTabData && activeTabData.logs && activeTabData.logs.length > 0;

        return (
        <div className="container">
            {!hasData && <h1 className="header-title">API Dashboard</h1>}

            <TokenInput
                apikey={apikey}
                setAPIKey={setAPIKey}
                onSearch={fetchData}
                loading={loading}
                hasData={hasData}
            />

            <StatusCards
                data={activeTabData}
                loading={loading}
            />

            {hasData && (
                <>
                    <UsageChart
                        logs={activeTabData.logs}
                        selectedDate={selectedDate}
                        onDateChange={setSelectedDate}
                        dollarCost={dollarCost}
                        setDollarCost={setDollarCost}
                        showRMB={showRMB}
                        setShowRMB={setShowRMB}
                    />

                    <LogsList
                        logs={activeTabData.logs}
                        loading={loading}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                    />
                </>
            )}

            {/* 公告弹窗 */}
            {announcementData && (
                <Modal
                    title={announcementData.title}
                    visible={showAnnouncement}
                    onOk={() => setShowAnnouncement(false)}
                    onCancel={() => setShowAnnouncement(false)}
                    okText={announcementData.okText}
                    cancelText="关闭"
                    centered
                    width={600}
                >
                    <div style={{ lineHeight: 1.8 }}>
                        {announcementData.items && announcementData.items.map((item, index) => (
                            <div key={index} style={{ marginBottom: 16 }}>
                                <Text strong style={{ fontSize: 16, color: '#0071e3' }}>问题{index + 1}：</Text>
                                <div style={{ marginBottom: 8 }}>{item.question}</div>
                                <Text strong style={{ color: '#34c759' }}>解答：</Text>
                                <div style={{ color: '#666' }}>{item.answer}</div>
                            </div>
                        ))}
                    </div>
                </Modal>
            )}

            <Footer style={{ textAlign: 'center', padding: '40px 0', color: 'var(--apple-text-secondary)' }}>
                Designed with <span style={{ color: '#ff3b30' }}>♥</span> by NekoAPI
            </Footer>
        </div>
    );
    };

    return (
        <Layout style={{ background: 'transparent' }}>
            <Content>
                {Object.keys(baseUrls).length > 1 ? (
                    <Tabs type="line" onChange={handleTabChange} activeKey={activeTabKey} style={{ display: 'flex', justifyContent: 'center' }}>
                        {Object.entries(baseUrls).map(([key]) => (
                            <TabPane tab={key} itemKey={key} key={key}>
                                {renderContent()}
                            </TabPane>
                        ))}
                    </Tabs>
                ) : (
                    renderContent()
                )}
            </Content>
        </Layout>
    );
};

export default LogsTable;

